import axios from "axios";

const URL_V2 = 'https://'+ process.env.VUE_APP_CONGRESS_SHORT +'.eposter.documedias.systems/api/v2';
// const URL_V2 = 'http://eposter-api.entwicklung:8030/api/v2';
export default {
  namespaced: true,

  state: {
    authorList: {},
    selectedAuthor: ''
  },
  actions: {
    GET_AUTHORS: function ({commit}) {
      let url = URL_V2 + '/gallery/author/list';
      axios.get(url).then((response) => {
        commit('SET_AUTHORLIST', {authorList: response.data})
      })
    },
  },
  mutations: {
    setSelectedAuthor(state, selectedAuthor) {
      state.selectedAuthor = selectedAuthor;
    },
    SET_AUTHORLIST: (state, {authorList}) => {
      state.authorList = authorList;
    },
  },
  getters: {}
}
